
/* eslint-disable max-len */
import React, { useState, useRef, useEffect, useContext } from 'react';
import CustomOverLay from '../../../../components/CustomOverLay';
import GlobalContext from '../../../../components/Context/GloablContext';
import Emptyscreenwithouttitle from '../../../../components/Emptyscreenwithouttitle';
import ProviderAssociatedExport from './ViewExport/ProviderExport';
import { useExportPatientsAssociatedToProviderMutation } from '../../../../features/providerSlice';
import { useUpdatePatientAlertsMutation } from '../../../../features/patientSlice';
import AlertToggleCell from '../../../../components/AlertToggleCell';

export default function ViewAssociatedPatientListing({ providerInfo, provider_id, result, setPatientQueryParams,patientQueryParams}) {
    const { isSideBar, setToastmessage, setToastErrorMessage } = useContext(GlobalContext);
    const [isColumnSelect, setIsColumnSelect] = useState(false);
    const [limit, setLimit] = useState(15);
    const [exportPatientsAssociated] = useExportPatientsAssociatedToProviderMutation()
    const [updatePatientAlerts] = useUpdatePatientAlertsMutation()
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');
    const [sortSelected,setisSortSelected] = useState(false)
    const [totalPageNumber, setTotalPageNumber] = useState(1);

    const handleAlertToggle = async (patient, field, newValue) => {
        try {
            const response = await updatePatientAlerts({
                patient_id: patient?.patient_id,
                body: {
                    user_id: provider_id,
                    user_type: 'provider',
                    [field]: newValue
                }
            })
            if (response?.error) {
                setToastErrorMessage(response?.error?.data?.message || 'Something went wrong. Please try again')
                return false
            } else {
                setToastmessage('Alert setting updated successfully')
                return true
            }
        } catch {
            setToastErrorMessage('Something went wrong. Please try again')
            return false
        }
    }

    const fetchPageAndLimit = () => {

        const splitQuery = patientQueryParams?.split('?')[1];
        const params = new URLSearchParams(splitQuery);
        return params
    }

    const handlePrevClick = () => {
        setisSortSelected(false)
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) - 1);
    };

    const handleNextClick = () => {
        setisSortSelected(false)
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) + 1);
    };
    const limitArr = [15, 30, 50, 100];
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);





    function handleNoOfRowsClick(number) {
        setisSortSelected(false)
        const params = fetchPageAndLimit()
        setPatientQueryParams(`${patientQueryParams.split('?')[0]}?page_number=1&limit=${number}&user_id=${provider_id}`);
    }

    const handleOnClickPageNumber = (pageNum) => {
        const params = fetchPageAndLimit()
        setPatientQueryParams(`${patientQueryParams.split('?')[0]}?page_number=${pageNum}&limit=${params.get("limit")}&user_id=${provider_id}`);
    };

    const calculateTotalPages = (totalRecords, limit) => {
        return Math.ceil(totalRecords / limit);
    };

    useEffect(() => {
        const calculatedTotalPages = calculateTotalPages(result?.data?.total_count, fetchPageAndLimit().get("limit"));
        setTotalPageNumber(calculatedTotalPages);
    }, [result]);

    const handleSort = (key) => {
        setisSortSelected(true)
        const params = fetchPageAndLimit()
        let sortValue = fetchPageAndLimit()?.get('sort')
        if(sortValue === ''||sortValue===undefined||sortValue===null) setPatientQueryParams(`${patientQueryParams.split('?')[0]}?page_number=${params.get("page_number")}&limit=${params.get("limit")}&user_id=${provider_id}&sort=${key}${encodeURIComponent('+asc')}`);
        else {
            if(sortValue.includes(key)) setPatientQueryParams(`${patientQueryParams.split('?')[0]}?page_number=${params.get("page_number")}&limit=${params.get("limit")}&user_id=${provider_id}&sort=${key}${encodeURIComponent('+')}${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else setPatientQueryParams(`${patientQueryParams.split('?')[0]}?page_number=${params.get("page_number")}&limit=${params.get("limit")}&user_id=${provider_id}&sort=${key}${encodeURIComponent('+asc')}`)
        }
    }

    return (
        <>
            <div className='border border-[#EDD7E1] mt-4 rounded pb-2'>
                <div className='relative flex  border-b border-[#EDD7E1] justify-between items-center  pr-4'>
                    <p className='text-base  w-full py-5 font-semibold pl-[17px] text-[#972E4C]' id="provider_patient_list">Patients List</p>
                    {result!==undefined&&result?.data?.data.length > 0&&<ProviderAssociatedExport
                        exportUsers={exportPatientsAssociated}
                        exportCols = {['ID' ,'Patient Name','Organization Name','Sub Division Name','Preference Mode','Send Alert']}
                        isColumnSelect = {isColumnSelect}
                        setIsColumnSelect = {setIsColumnSelect}
                        setIsFilterOpen={()=>{}}
                        provider_id={provider_id}
                        fetchPageAndLimit={fetchPageAndLimit}
                        patientQueryParams={patientQueryParams}
                        isIdexport={true}
                        TotalCount={parseInt(result?.data?.total_count)}
                    />}
                </div>

                {result?.data?.data && result?.data?.data.length === 0&&!result?.isFetching
                    ? <Emptyscreenwithouttitle FirstPTag={"No patients linked yet"} />
                    :
                    <>
                        {((result.status !== "fulfilled" && result.status !== "rejected") || (result === undefined && result.status !== "fulfilled" && result.status !== "rejected"))&&!sortSelected ?
                            <CustomOverLay Active text="Loading Patients list..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened_sidebar_overlay2' : 'overlay-list2'}`} /> : <>
                                <div className='overflow-auto scrollbar_purple pb-2.5'>
                                    <table id="patient_table" aria-label="Outside Table" className="w-full table-auto">
                                        <thead>
                                            <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm">
                                                <th id="patient_id" className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm min-w-[100px]" onClick={() => {handleSort('patient_id')}}>
                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                        ID <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={fetchPageAndLimit()?.get('sort') !== undefined && fetchPageAndLimit()?.get('sort')?.split("+")[0] === "patient_id" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                                    </span>
                                                </th>
                                                <th id="patient_name" className="px-[18px] py-2 min-w-[230px]" onClick={() => {handleSort('last_name')}}>
                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                        Patient Name <button   className="pl-2.5 sortedIcon"><img loading="lazy" className='min-w-[16px]' decoding="async" src={fetchPageAndLimit()?.get('sort') !== undefined && fetchPageAndLimit()?.get('sort')?.split("+")[0] === "last_name" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                                    </span>
                                                </th>
                                                <th id="organization_name"  className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm" onClick={() => {handleSort('organization_name')}}>
                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                        Organization Name                                    <button className="pl-2.5 sortedIcon"><img loading="lazy" className='min-w-[16px]' decoding="async" src={fetchPageAndLimit()?.get('sort') !== undefined && fetchPageAndLimit()?.get('sort')?.split("+")[0] === "organization_name" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                                    </span>
                                                </th>
                                                <th id="subdivision_name" className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm" onClick={() => {handleSort('subdivision_name')}}>
                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                        Sub Division Name                                     <button   className="pl-2.5 sortedIcon"><img loading="lazy" className='min-w-[16px]' decoding="async" src={fetchPageAndLimit()?.get('sort') !== undefined && fetchPageAndLimit()?.get('sort')?.split("+")[0] === "subdivision_name" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                                    </span>
                                                </th>
                                                <th className="px-[18px] py-2 min-w-[130px]">
                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alerts by SMS</span>
                                                </th>
                                                <th className="px-[18px] py-2 min-w-[130px]">
                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alerts by Email</span>
                                                </th>
                                                <th className="px-[18px] py-2 min-w-[180px] whitespace-nowrap">
                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Include Missed Readings</span>
                                                </th>
                                                <th className="px-[18px] py-2 min-w-[145px] rounded-tl-sm rounded-bl-sm">
                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                        Preference Mode
                                                    </span>
                                                </th>
                                                <th className="px-[18px] py-2 min-w-[110px] rounded-tl-sm rounded-bl-sm">
                                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                        Send Alert
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {result?.data?.data && result?.data?.data.length > 0 && result?.data?.data.map((patient, index) => (

                                                <tr key={index}>
                                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                        {patient?.patient_id}
                                                    </td>
                                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                        {patient?.patientData?.first_name || ''} {patient?.patientData?.middle_name || ''} {patient?.patientData?.last_name || ''}
                                                    </td>
                                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]" style={{lineBreak:"anywhere"}}>
                                                        {patient?.patientData?.organization_name}
                                                    </td>
                                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]" style={{lineBreak:"anywhere"}}>
                                                        {patient?.patientData?.subdivision_name}
                                                    </td>
                                                    <AlertToggleCell
                                                        initialValue={patient?.sms_alert === true}
                                                        disabled={!providerInfo?.main_number || providerInfo?.main_number?.trim() === ""}
                                                        id={`${index}providersms`}
                                                        onToggle={(newValue) => handleAlertToggle(patient, 'sms_alert', newValue)}
                                                    />
                                                    <AlertToggleCell
                                                        initialValue={patient?.email_alert === true}
                                                        disabled={false}
                                                        id={`${index}provideremail`}
                                                        onToggle={(newValue) => handleAlertToggle(patient, 'email_alert', newValue)}
                                                    />
                                                    <AlertToggleCell
                                                        initialValue={patient?.missed_reading_alert === true}
                                                        disabled={false}
                                                        id={`${index}providermissed`}
                                                        onToggle={(newValue) => handleAlertToggle(patient, 'missed_reading_alert', newValue)}
                                                    />
                                                    <td className="px-[18px] py-2 text-sm text-start font-normal">
                                                        <div className="flex items-center justify-start">
                                                            <img loading="lazy" decoding="async" src={`${patient?.preference_mode==="email"?"/images/PreferenceEmail.svg":'/images/PreferencePhone.svg'}`} alt="icon" />
                                                            <span className="text-sm text-start font-normal text-[#000000] pl-2">{patient?.preference_mode==="email" ? "Email" : "Call"}</span>
                                                        </div>
                                                    </td>
                                                    <td className="px-[18px] py-2 text-sm text-start font-normal">
                                                        <span className={`${patient?.send_alert===false ? 'bg-[#E7EAF4] text-[#000000] px-1.5 py-0.5 rounded-[28px]' : 'bg-[#C0ECCE] text-[#1A883C] px-1.5 py-0.5 rounded-[28px]'}`}>
                                                            {patient?.send_alert===false ? "Disable" : "Enable"}
                                                        </span>
                                                    </td>
                                                </tr>

                                            ))}

                                        </tbody>
                                    </table>
                                </div>

                                {result?.data && result?.data?.total_count > 15 &&
                                <div className="w-[100%] px-2.5 pt-0 flex items-center justify-between bg-[#F4F7FC]">
                                    <p className="text-sm font-semibold text-[#687182]">
                                        Total Number of Records: {result?.data?.total_count}
                                    </p>
                                    <div className="flex items-center">
                                        <div className={`${isColumnSelect ? 'pl-1' : 'relative pl-1'}`}>
                                            <button
                                                ref={buttonRef}
                                                onClick={() => setIsOpen(!isOpen)}
                                                type="button"
                                                className="text-sm font-semibold text-[#687182] flex items-center"
                                            >
                                                <p>Rows per page: {fetchPageAndLimit().get("limit")}</p>
                                                <span className="pl-0.5">
                                                    <img
                                                        src="/images/down.svg"
                                                        className={`${isOpen ? "transform rotate-180" : ""}`}
                                                        alt="icon"
                                                        onClick={() => setIsOpen(!isOpen)}
                                                    />
                                                </span>
                                            </button>
                                            <ul
                                                className={`absolute top-[-140px] left-[96px] pl-[10px] py-1.5 pr-0.5 z-[9999] bg-white border border-white h-fit rounded-sm shadow-xl ${isOpen ? "" : "hidden"}`}
                                                ref={dropdownRef}
                                            >
                                                <li>
                                                    <ul className="max-h-[110px] overflow-auto pr-2 bg-white scrollbar_gray_thin ">
                                                        {limitArr.map((item, index) => (
                                                            <li key={index}>
                                                                <h1
                                                                    onClick={() => {
                                                                        setLimit(item);
                                                                        setIsOpen(false);
                                                                        handleNoOfRowsClick(item);
                                                                    }}
                                                                    className={`text-base font-normal cursor-pointer ${item === parseInt(limit) ? "text-[#008586]" : "text-[#00000]"
                                                                    } mb-[16px]`}
                                                                >
                                                                    {item}
                                                                </h1>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="flex items-center ml-5">
                                            <button
                                                disabled={parseInt(fetchPageAndLimit().get("page_number")) === 1}
                                                onClick={handlePrevClick}
                                                className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                                            >
                                                <img src="/images/left.svg" alt="icon" />
                                            </button>
                                            <p className="text-sm font-semibold text-[#687182] mx-2.5">
                                                <span className="text-[#171C26]">{fetchPageAndLimit().get("page_number")}</span>/{totalPageNumber}
                                            </p>
                                            <button
                                                disabled={parseInt(fetchPageAndLimit().get("page_number")) === totalPageNumber}
                                                onClick={handleNextClick}
                                                className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                                            >
                                                <img src="/images/right.svg" alt="icon" />
                                            </button>
                                        </div>
                                    </div>
                                </div>}
                            </>}

                    </>
                }




            </div>

        </>
    )
}
